import React from "react";
import { useHistory } from "react-router-dom";
import { modules } from "./moduleConstants";
import "./importantDocument.css";
export const ImportantDocumentMain = () => {
  const history = useHistory();

  const handleDocumentSelect = (name) => {
    history.push(`/orgainzer/important-document/${name}`);
  };

  return (
    <div className="reportsMain">
      <div className="reportcreate" style={{ justifyContent: "space-between" }}>
        <h3 className="selectHeadingMainDocs">Important Documents</h3>
      </div>
      <div className="selectHeadingDoc">
        Select Module to View attached Documents
      </div>
      <div className="selectmainDocs" style={{ justifyContent: "flex-start" }}>
        {modules &&
          modules.map((item, index) => (
            <div
              key={index}
              onClick={() => {
                handleDocumentSelect(item.name);
              }}
              className="selectMaincardsDocs"
            >
              <div className="selectMaincardsDocsInner">
                {" "}
                <div className="selectMainImagesDocs">
                  <img src={item.image} height={"40px"} alt={item.title} />{" "}
                </div>
                <div className="selectMainHeaderDocs">
                  <span className="selectheadingValueDocs">{item.title}</span>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};
